import React from "react";
import DialogWrapper from "./DialogWrapper";
import { Typography, useTheme } from "@mui/material";

const DialogSeasonConfirmation = ({
    open,
    actionMethod,
    season = null,
    fullWidth = true,
    fullScreen = false,
}) => {
    const theme = useTheme();

    const title = Boolean(season) ? `Inscrição na Época ${season}` : "Inscrição de Atleta";
    const initMessage = Boolean(season) ? ` na Época ${season}` : "";

    return (
        <DialogWrapper
            open={open}
            title={title}
            onClose={() => actionMethod("cancel")}
            onCancel={() => actionMethod("cancel")}
            onConfirm={() => actionMethod("submit")}
            labelCancel="Cancelar"
            labelConfirm="Confirmar"
            fullWidth={fullWidth}
            fullScreen={fullScreen}>
            <Typography>Ao confirmar a inscrição{initMessage}, está a aceitar as seguintes condições de inscrição:</Typography>
            <ul>
                <li>
                    Pagamento da quota de sócio anual, da jóia de inscrição e das quotas suplementares mensais.
                    O atleta deverá também suportar o custo com o equipamento personalizado (no mínimo deverá ser adquirido o equipamento
                    principal e secundário). Para quaisquer esclarecimentos adicionais sobre os pagamentos e os montantes, por favor,
                    entre em contacto com a Direção.
                </li>
                <li style={{marginTop: theme.spacing(2)}}>
                    Autorização do tratamento dos dados pessoais e imagem pela ADCB para uso no âmbito da atividade desportiva, marketing, publicidade e divulgação do clube. 
                    Caso pretenda a revogação da mesma deverá contatar a Direção da ADCB.
                </li>
                <li style={{marginTop: theme.spacing(2)}}>
                    Autorização para a deslocação dos atletas em transporte da ADCB ou de outros encarregados de educação,
                    sempre que a ADCB não consiga assegurar o transporte.
                </li>
                <li style={{marginTop: theme.spacing(2)}}>
                    Tomei conhecimento que, após estar devidamente inscrito na FAP, o atleta está abrangido por um Seguro Desportivo de acordo com as condições da FAP.
                    O seguro desportivo poderá ser ativado a qualquer momento e os custos de tratamento e outros que superem a cobertura do seguro não serão assumidos pela ADCB.
                    As despesas de tratamentos e outras cobertas pelo seguro ascendem até 5.000,00 €.
                </li>
            </ul>
            <Typography variant="button">
                Caso não autorize todos os pontos acima, por favor, utilize um método alternativo para comunicar a sua
                decisão, nomeadamente através do contacto com a Direção da ADCB.
            </Typography>
        </DialogWrapper>
    )
}

export default DialogSeasonConfirmation;
